import api from '@/lib/axios';

export const customerPaymentsService = {
  findAll: async (companyId: string) => {
    const response = await api.get('/customer-payments', {
      params: { companyId }
    });
    return response.data;
  },

  create: async (data: {
    companyId: string;
    customerId: string;
    amount: number;
    paymentMethod: string;
    reference?: string;
    notes?: string;
  }) => {
    const response = await api.post('/customer-payments', data);
    return response.data;
  }
};
